<template>
  <div class="mt-10 bg-gradient-to-r from-primary-light to-ternary-light shadow-soft dark:from-ternary-dark dark:to-secondary-dark sm:mt-20">
    <!-- About me counters start -->
    <div class="container mx-auto block py-20 text-center sm:flex sm:items-center sm:justify-between">
      <!-- Years of experience counter -->
      <div class="mb-20 sm:mb-0">
        <span class="mb-2 bg-gradient-to-r from-accent to-gradient-end bg-clip-text text-5xl font-bold text-transparent">20+</span>
        <span class="text-md block text-ternary-dark dark:text-ternary-light">Years in tech</span>
      </div>

      <!-- Freelance experience counter -->
      <div class="mb-20 sm:mb-0">
        <span class="mb-2 bg-gradient-to-r from-accent to-gradient-end bg-clip-text text-5xl font-bold text-transparent">13+</span>
        <span class="text-md block text-ternary-dark dark:text-ternary-light">Freelance years</span>
      </div>

      <!-- Technologies mastered counter -->
      <div class="mb-20 sm:mb-0">
        <span class="mb-2 bg-gradient-to-r from-accent to-gradient-end bg-clip-text text-5xl font-bold text-transparent">15+</span>
        <span class="text-md block text-ternary-dark dark:text-ternary-light">Technologies</span>
      </div>

      <!-- Projects completed counter -->
      <div class="mb-20 sm:mb-0">
        <span class="mb-2 bg-gradient-to-r from-accent to-gradient-end bg-clip-text text-5xl font-bold text-transparent">100+</span>
        <span class="text-md block text-ternary-dark dark:text-ternary-light">Projects delivered</span>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
// This component only contains static content, no reactive data needed
</script>
